import React, { FC } from 'react';
import { useDataTableQuickReportsContext } from '../../../../utils/DataTableQuickReportsContext';
import { getActiveQuickReport } from '../../../../DataTableAdvancedElements/DataTableQuickReports/utils/QuickReports.utils';
import { DataTableExportActions } from './DataTableExportActions';

export const DataTableExport: FC<{
  ExportDialogProps?: { children?: React.ReactNode };
  ScheduleExportDialogProps?: { children?: React.ReactNode };
}> = ({ ExportDialogProps, ScheduleExportDialogProps }) => {
  const { activeQuickReportId, quickReports } = useDataTableQuickReportsContext();

  const activeQuickReport = getActiveQuickReport(quickReports, activeQuickReportId);

  return (
    <DataTableExportActions
      onOpen={undefined}
      source="table-tool-bar"
      report={activeQuickReport}
      ExportDialogProps={ExportDialogProps}
      ScheduleExportDialogProps={ScheduleExportDialogProps}
    />
  );
};
